// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cta_cards__kaXLj","card":"Cta_card__edo+l","img":"Cta_img__dVQT1","btn":"Cta_btn__SZepp"};